import globals from "./globals";
import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

const component = (function () {
    /**
     * Initialize Hero instances
     */
    $(window).on("preloaderHidden", function () {
        if ($("#panorama").length) {
            if (globals.debug) console.log("component-panorama initialized");
            var instance = $("#panorama");
            var image = instance.find(".panorama-image");
            var wrapper = instance.find(".panorama-inner");

            gsap.registerPlugin(ScrollTrigger);
            gsap.fromTo(
                image[0],
                { rotation: 90, y: 0, scale: 1.1 },
                {
                    rotation: 0,
                    y: "50%",
                    scale: 3,
                    ease: "none",
                    scrollTrigger: {
                        trigger: wrapper[0],
                        start: "top top",
                        end: "bottom-=20% bottom",
                        scrub: 1,

                        // markers: true,
                    },
                }
            );
        }
    });
})();

export default component;
